import React from "react";
import '../css/sg-platform.css';

const Popup = ({ title, content, onClose }) => {
  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close" onClick={onClose}>
          &times;
        </button>
        {title && <h2 className="popup-title-ty">{title}</h2>}
        <div className="popup-body-ty">
          {content}
        </div>
      </div>
    </div>
  );
};

export default Popup;